module.exports = "/assets/hero-xmas.png?nC3p1Ft";